<template>
  <li class="frisbuy-gallery-post pn-ad-post">
    <div class="frisbuy-post-image" @click="$emit('open-ad-popup')">
      <img
        :src="`${envDomain}/images/gulliver_wear_new.png`"
        alt=""
      />
    </div>
  </li>
</template>

<script>
const bodyScrollLock = require('body-scroll-lock');

export default {
  data() {
    return {
      showPopup: false,
      hashCopied: false
    };
  },

  props: ['settings']
};
</script>

<style lang="scss">
.frisbuy-gallery-post.pn-ad-post {
  cursor: pointer;
  color: #2c2c2c;
  position: relative;
  flex-shrink: 0;

  .frisbuy-post-image {
    width: 100%;
    padding-bottom: 100%;

    & > img {
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }
}

.pn-ad-title {
  font-weight: bold;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-top: 25px;
}

.pn-ad-description {
  font-size: 14px;
  line-height: 19px;
  margin-top: 24px;
}

.pn-ad-upload-button {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  margin-top: 40px;
  cursor: pointer;
}

.pn-ad-tag-text {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  margin-top: 16px;
  border-bottom: 1px solid #c0c0c0;
}

.pn-ad-divider {
  flex-grow: 1;
}

.pn-ad-hint {
  font-size: 12px;
  line-height: 18px;
}

.frisbuy-popup-media {
  width: 531px;

  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.frisbuy-details-scroller {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  a {
    text-decoration: none;
    color: inherit;
    border-bottom: 1px solid #c0c0c0;
  }
}

.frisbuy-popup-details:after {
  display: none;
}

.frisbuy-popup-overlay {
  cursor: default;
}

.frisbuy-popup {
  padding: 51px;
}

.le-hash-copied {
  padding: 10px 61px;
  position: absolute;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  color: #2c2c2c;
  background: #ffffff;
  border: 1px solid #c0c0c0;
  border-radius: 56px;
  bottom: 10px;
  left: calc(50% - 141px);

  &.le-hash-enter-active {
    opacity: 0;
    transition: opacity 1s;
  }

  &.le-hash-enter-to {
    opacity: 1;
  }

  &.le-hash-leave-active {
    opacity: 1;
    transition: 1s opacity 3s;
  }

  &.le-hash-leave-to {
    opacity: 0;
  }
}

@media only screen and (max-width: 1199px) {
  .frisbuy-popup {
    padding: 10px;
  }

  .frisbuy-popup-media {
    width: 441px;
  }
}

@media only screen and (max-width: 767px) {
  .frisbuy-popup {
    padding: 0;
  }

  .frisbuy-popup-media {
    width: 100%;

    svg {
      position: absolute;
    }
  }

  .frisbuy-popup-details {
    padding: 0 30px;
  }

  .frisbuy-popup-controls {
    justify-content: flex-end !important;
  }

  .le-hash-copied {
    position: fixed;
  }
}
</style>
